import { render, staticRenderFns } from "./ComDownLoadFile.vue?vue&type=template&id=1b1bc041&scoped=true"
import script from "./ComDownLoadFile.vue?vue&type=script&lang=js"
export * from "./ComDownLoadFile.vue?vue&type=script&lang=js"
import style0 from "./ComDownLoadFile.vue?vue&type=style&index=0&id=1b1bc041&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1bc041",
  null
  
)

export default component.exports